import { formatDropDownOption } from '../../utils/reuseAbleInputs';

const ProviderDropDownInput = ({ data, setData, index, keyName, options, placeholder, rowCheck }) => {
  return (
    <select
      className='form-control arrow-btn'
      value={data[index] && data[index][keyName]}
      onChange={(e) => {
        const temp = [...data];
        temp[index][keyName] = e.target.value;
        temp[index].error = false;
        setData([...temp]);
        rowCheck(true, temp[index].m_id);
      }}
    >
      <option className='placeholder' value=''>
        {placeholder}
      </option>
      {options.map((each) => {
        return (
          <option value={each} key={each} className='uppercase'>
            {each}
          </option>
        );
      })}
    </select>
  );
};

export default ProviderDropDownInput;
